import { toRaw } from 'vue';
import router from '../router';

export default {
    setKitId(state, id) {
        state.kitId = id;
        
        state.current = Object.entries(toRaw(state.lists)).find(x => x[1].id === state.kitId)[1];
    },

    initStep(state) {
        state.step = false;
    },

    prevStep(state) {
        state.step = state.step - 1;
    },

    nextStep(state) {
        state.step = !state.step ? 1 : state.step + 1;
    },

    addToCart(state, {product, qtt, variation, attributes}) {

        state.cart[state.kitId] = state.cart[state.kitId] || {};
        state.cart[state.kitId][state.step] = state.cart[state.kitId][state.step] || {};

        const pid = !variation ? product.id : variation.variation_id;
        let qty = qtt;

        if (state.cart.length && 
            typeof state.cart[state.kitId][state.step][pid] != 'undefined' && 
            state.cart[state.kitId][state.step][pid].hasOwnProperty('qtt')) {

            qty = state.cart[state.kitId][state.step][pid].qtt + qtt;

        }

        state.cart[state.kitId][state.step][pid] = {
            product: product,
            qtt: qty,
            variation: variation,
            attributes
        };
    },

    updateCartItemQtt(state, {step, pid, qtt}) {
        state.cart[state.kitId][step][pid].qtt = qtt;
    },

    removeFromCart(state, {step, pid}) {
        delete state.cart[state.kitId][step][pid];

        // remove group if it empty
        if (!Object.keys(state.cart[state.kitId][step]).length) {
            delete state.cart[state.kitId][step];
        }

        // redirect to kit builder
        if (this.getters.isCartEmpty) {
            router.push(`/${state.kitId}`);
        }
    },

    resetKit(state) {
        state.cart[state.kitId] = {};
        state.step = 1;
        router.push(`/${state.kitId}`);
    }
 }